import styled from "styled-components";

export const ContainerLayout = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
`; 

export const ContainerContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
`; 

export const ContainerChildren = styled.div`
    width: calc(100% - 314px);
    height: 100%;
    position: relative;
`;
